jQuery(function ($, undefined) {
  $('.button-group__item .button').on('click', function() {
    if(!$(this).hasClass('button--active')) {
      $('.button-group__item .button').removeClass('button--active');
      $(this).addClass('button--active');
      
      if($(this).hasClass('list') && !$('.list-view').is(':visible')) {
        $('.cal-view').hide();
        $('.list-view').show();
      } else if($(this).hasClass('calendar-view') && !$('.cal-view').is(':visible')) {
        $('.list-view').hide();
        $('.cal-view').show();
      }
    }
  });

  $('.has-tooltip span').tipso({
    position: 'top',
    background: '#8b909a',
    color: '#fff',
    tooltipHover: true
  });

  var url = window.location.href.replace(/^https?:\/\//, '').split('/')[4];

  $('.venue__nav a').each(function() {
    var linkurl = $(this).attr('data-url');
    
    if(linkurl == url) {
      $('.venue__nav a').removeClass('active');
      $(this).addClass('active');
    }
  }); 
  
  // Commented out for now since each link is a new page load
  $(document).on('click', '.venue__nav a', function(e) {
    e.preventDefault();
    var content = $('.cobrand-body');
    var linkurl = $(this).attr('data-url');
    var url = window.location.href.replace(/^https?:\/\//, '').split('/')[1];
    var oldURL = ('' + window.location.href).split('/venue/');

    content.load('../' + linkurl + '/index.jsp', function(response, status, xhr) {
      content.html(response);
      history.replaceState('data', '', oldURL[0] + '/venue/' + linkurl + '/index.jsp');

      $('.venue__nav a').removeClass('active');
      $('.venue__nav a[data-url="' + linkurl + '"]').addClass('active');
    });
  });
});
